import angular from "angular";

import AdminNotificationsModuleRouting from "./admin-notifications.module.routing";

export default angular
  .module("vt-admin-notifications", [])
  .config(AdminNotificationsModuleRouting);
